import React, { useState, useEffect } from 'react';
import './Header.css';
import { API, authHeadersOnly } from '../services/apiConfig';
import Notifications from './Notifications';
import SearchResults from './SearchResults';

function Header({ onContactClick, onLoginClick, onCartClick, user, onLogout, onShowOrders, onShowAccountDashboard, onProductClick }) {
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isCompactSearchFocused, setIsCompactSearchFocused] = useState(false);
  const [isLogoHovered, setIsLogoHovered] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('standard');
  const [notificationCount, setNotificationCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [bannerIndex, setBannerIndex] = useState(0);
  const banners = [
    { src: '/images/eco-friendly banner.png', alt: 'Eco Friendly' },
    { src: '/images/diaries banner 2.png', alt: 'Diaries' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setBannerIndex(i => (i + 1) % 2);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const sidebarTouchStartX = React.useRef(null);
  const handleSidebarTouchStart = (e) => { sidebarTouchStartX.current = e.touches[0].clientX; };
  const handleSidebarTouchEnd = (e) => {
    if (sidebarTouchStartX.current === null) return;
    const diff = sidebarTouchStartX.current - e.changedTouches[0].clientX;
    if (diff > 60) setIsSidebarOpen(false); // swipe left to close
    sidebarTouchStartX.current = null;
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    const handleResize = () => {
      if (window.innerWidth > 991) setIsSidebarOpen(false);
    };
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (user?.userId) {
      fetchNotificationCount();
      const interval = setInterval(fetchNotificationCount, 30000);
      return () => clearInterval(interval);
    }
  }, [user]);

  const fetchNotificationCount = async () => {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000);
      const response = await fetch(`${API}/api/notifications/user/${user.userId}/unread-count`, { signal: controller.signal, headers: authHeadersOnly() });
      clearTimeout(timeout);
      if (!response.ok) return;
      const count = await response.json();
      setNotificationCount(count);
    } catch { }
  };

  const shopClick = (e) => {
    e.preventDefault();
    if (window.location.pathname === '/products') {
      const p = new URLSearchParams(window.location.search);
      const cat = p.get('category') || 'standard';
      window.location.href = `/products?category=${cat}`;
    } else {
      window.location.href = `/products?category=standard`;
    }
  };

  const navClick = (category, productName) => {
    window.location.href = `/products?category=${category}&q=${encodeURIComponent(productName)}`;
  };

  const categoryData = {
    standard: {
      ecoFriendly: ['Forest Card', 'Forest Dome', 'Forever Terrarium (Desk)', 'Forest Chronicles (Square)', 'Forest Chronicles (Panorama)', 'Forest Window', "Nature's Stage 1", 'Forest Tile (Trio)', 'Forest Sparkle (Write)'],
      stationery: ['Metal Pens', 'Round Metal Keychain', 'BK Metal Keychain', 'Gold BK Metal Keychain', 'Klix', 'Klix Pro'],
      corporateAddOns: ['Rim Handle Mugs', 'Lapido', 'Urbix', 'Printed Mouse Pad (Round)', 'Sipper Bottle (600ml)', 'Two Tone Mugs'],
      travellingAddOns: ['Pac N Go Passport', 'Pac N Go Sling 2', 'Travel Pro 40', 'Rock & Ice 40', 'Stark Overnighter', 'Orion Overnighter', 'Classic Overnighter']
    },
    premium: {
      ecoFriendly: ['Forest Card', 'Forest Dome', 'Forever Terrarium (Desk)', 'Forest Chronicles (Square)', 'Forest Chronicles (Panorama)', 'Forest Window', "Nature's Stage 1", 'Forest Tile (Trio)', 'Forest Sparkle (Write)'],
      stationery: ['Metal Pens', 'Round Metal Keychain', 'BK Metal Keychain', 'Gold BK Metal Keychain', 'Klix', 'Klix Pro'],
      corporateAddOns: ['Rim Handle Mugs', 'Lapido', 'Urbix', 'Printed Mouse Pad (Round)', 'Sipper Bottle (600ml)', 'Two Tone Mugs'],
      travellingAddOns: ['Pac N Go Passport', 'Pac N Go Sling 2', 'Travel Pro 40', 'Rock & Ice 40', 'Stark Overnighter', 'Orion Overnighter', 'Classic Overnighter']
    },
    superPremium: {
      ecoFriendly: ['Forest Card', 'Forest Dome', 'Forever Terrarium (Desk)', 'Forest Chronicles (Square)', 'Forest Chronicles (Panorama)', 'Forest Window', "Nature's Stage 1", 'Forest Tile (Trio)', 'Forest Sparkle (Write)'],
      stationery: ['Metal Pens', 'Round Metal Keychain', 'BK Metal Keychain', 'Gold BK Metal Keychain', 'Klix', 'Klix Pro'],
      corporateAddOns: ['Rim Handle Mugs', 'Lapido', 'Urbix', 'Printed Mouse Pad (Round)', 'Sipper Bottle (600ml)', 'Two Tone Mugs'],
      travellingAddOns: ['Pac N Go Passport', 'Pac N Go Sling 2', 'Travel Pro 40', 'Rock & Ice 40', 'Stark Overnighter', 'Orion Overnighter', 'Classic Overnighter']
    }
  };


  return (
    <>
      {isSidebarOpen && <div className="sidebar-backdrop" onClick={toggleSidebar}></div>}
      <div className={`sidebar-menu ${isSidebarOpen ? 'open' : ''}`}
        onTouchStart={handleSidebarTouchStart}
        onTouchEnd={handleSidebarTouchEnd}
      >
        <div className="sidebar-header">
          <button className="sidebar-close" onClick={toggleSidebar}>×</button>
        </div>
        <nav className="sidebar-nav">
          <a href="index.html" onClick={toggleSidebar}>Home</a>
          <a href="#standard" onClick={toggleSidebar}>Shop</a>
          <a href="#about-corgif" onClick={(e) => {
            e.preventDefault();
            toggleSidebar();
            if (window.location.pathname === '/') {
              setTimeout(() => {
                document.getElementById('why-corgif')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 300);
            } else {
              sessionStorage.setItem('scrollTarget', 'why-corgif');
              window.location.href = '/';
            }
          }}>About corgif</a>
          <a href="/contact" onClick={toggleSidebar}>Contact</a>
          {user && (
            <a href="#" onClick={(e) => { e.preventDefault(); onCartClick(); toggleSidebar(); }}>
              Cart
            </a>
          )}
          {user ? (
            <>
              <a href="#" onClick={(e) => { e.preventDefault(); onShowAccountDashboard(); toggleSidebar(); }}>
                Account Dashboard
              </a>
              <a href="#" onClick={(e) => { e.preventDefault(); onShowOrders(); toggleSidebar(); }}>
                My Orders
              </a>
              <a href="#" onClick={(e) => { e.preventDefault(); onLogout(); toggleSidebar(); }}>Logout</a>
            </>
          ) : (
            <a href="/login" onClick={toggleSidebar}>Signup/Login</a>
          )}
          <a
            href="#enterprise"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleSidebar();
              if (window.location.pathname === '/') {
                setTimeout(() => {
                  document.getElementById('enterprise-wrapper')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 400);
              } else {
                window.location.href = '/#enterprise-wrapper';
              }
            }}
            className="sidebar-enterprise-btn"
          >
            <i className="fas fa-building"></i> For Enterprise
          </a>
        </nav>
      </div>
      
      <header id="header" className={`header tra-menu navbar-light ${isScrolled ? 'header-hidden' : ''}`}>
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          <i className="fas fa-bars"></i>
        </button>

        {/* ── Mobile topbar (visible only on ≤991px) ── */}
        <div className="mobile-topbar">
          <a href="index.html">
            <img src="images/corgif-logo.png" alt="logo" className="mobile-topbar-logo" />
          </a>
          <div className="mobile-topbar-right">
            {user && (
              <a href="#" onClick={(e) => { e.preventDefault(); onCartClick(); }} className="mobile-topbar-icon">
                <i className="fas fa-shopping-cart"></i>
              </a>
            )}
            {user && (
              <a href="#" onClick={(e) => { e.preventDefault(); setShowNotifications(!showNotifications); }} className="mobile-topbar-icon">
                <i className="fas fa-bell"></i>
                {notificationCount > 0 && <span className="notification-badge">{notificationCount}</span>}
              </a>
            )}
            <button className="mobile-topbar-hamburger" onClick={toggleSidebar} aria-label="Open menu">
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
        
        <div className="header-wrapper" style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 40px' }}>
          <div className="wsmainfull menu clearfix">
            <div className="wsmainwp clearfix">
              <div className="desktoplogo" style={{ marginTop: '10px', position: 'relative' }} onMouseEnter={() => setIsLogoHovered(true)} onMouseLeave={() => setIsLogoHovered(false)}>
                <a href="corgif.html" className="logo-black" style={{ position: 'relative', display: 'inline-block' }}>
                  <img src="images/corgif-logo.png" alt="header-logo" style={{ height: '140px', width: 'auto', transform: isLogoHovered ? 'perspective(500px) rotateY(-8deg)' : 'none', transformOrigin: 'left center', transition: 'transform 0.3s' }} />
                </a>
              </div>

              <nav className="wsmenu clearfix">
                <ul className="wsmenu-list" style={{ display: 'flex', gap: '30px', minWidth: '700px', justifyContent: 'flex-start' }}>
                  <li className="nl-simple" aria-haspopup="true">
                    <a href="index.html" className="nav-link">Home</a>
                  </li>
                  <li className="nl-simple mega-dropdown-container" aria-haspopup="true" style={{ position: 'relative' }}>
                    <a href="/" className="nav-link" onClick={(e) => {
                      e.preventDefault();
                      if (window.location.pathname === '/products') {
                        window.location.href = '/products';
                      } else if (window.location.pathname === '/') {
                        document.getElementById('standard')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      } else {
                        window.location.href = '/products';
                      }
                    }}>Shop</a>
                    <div className="mega-dropdown">
                      <div className="mega-dropdown-content-new">
                        <div className="category-sidebar">
                          <button 
                            className={`category-btn-new standard ${selectedCategory === 'standard' ? 'active' : ''}`}
                            onClick={() => setSelectedCategory('standard')}
                          >
                            <span className="category-icon">🎁</span>
                            <span className="category-text">Standard</span>
                            <div className="hover-card">
                              <div className="hover-card-icon">🎁</div>
                              <div className="hover-card-content">
                                <h4>Standard</h4>
                                <p>For internal teams, small events, and quick gifting.</p>
                                <span className="cost-text">Costing: Up to Rs. 1000</span>
                              </div>
                            </div>
                          </button>
                          <button 
                            className={`category-btn-new premium ${selectedCategory === 'premium' ? 'active' : ''}`}
                            onClick={() => setSelectedCategory('premium')}
                          >
                            <span className="category-icon">🎁</span>
                            <span className="category-text">Premium</span>
                            <div className="hover-card">
                              <div className="hover-card-icon">🎁</div>
                              <div className="hover-card-content">
                                <h4>Premium</h4>
                                <p>For clients, partners, and mid-level celebrations.</p>
                                <span className="cost-text">Costing: Rs. 1000 – Rs. 5000</span>
                              </div>
                            </div>
                          </button>
                          <button 
                            className={`category-btn-new super-premium ${selectedCategory === 'superPremium' ? 'active' : ''}`}
                            onClick={() => setSelectedCategory('superPremium')}
                          >
                            <span className="category-icon">🎁</span>
                            <span className="category-text">Super Premium</span>
                            <div className="hover-card">
                              <div className="hover-card-icon">🎁</div>
                              <div className="hover-card-content">
                                <h4>Super Premium</h4>
                                <p>For CXOs, leadership teams, and landmark occasions.</p>
                                <span className="cost-text">Costing: Rs. 5000 - Rs. 60000</span>
                              </div>
                            </div>
                          </button>
                        </div>
                        <div className="category-content">
                          <div className="product-columns">
                            <div className="product-column-new eco-friendly-split">
                              <h4>Eco-Friendly</h4>
                              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                <ul>
                                  {categoryData[selectedCategory].ecoFriendly.slice(0, 5).map((item, idx) => (
                                    <li key={idx} onClick={() => navClick(selectedCategory, item)} style={{ cursor: 'pointer' }}>{item}</li>
                                  ))}
                                </ul>
                                <ul>
                                  {categoryData[selectedCategory].ecoFriendly.slice(5).map((item, idx) => (
                                    <li key={idx} onClick={() => navClick(selectedCategory, item)} style={{ cursor: 'pointer' }}>{item}</li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                            <div className="product-column-new">
                              <h4>Stationery</h4>
                              <ul>
                                {categoryData[selectedCategory].stationery.map((item, idx) => (
                                  <li key={idx} onClick={() => navClick(selectedCategory, item)} style={{ cursor: 'pointer' }}>{item}</li>
                                ))}
                              </ul>
                            </div>
                            <div className="product-column-new">
                              <h4>Corporate Add-Ons</h4>
                              <ul>
                                {categoryData[selectedCategory].corporateAddOns.map((item, idx) => (
                                  <li key={idx} onClick={() => navClick(selectedCategory, item)} style={{ cursor: 'pointer' }}>{item}</li>
                                ))}
                              </ul>
                            </div>
                            <div className="product-column-new">
                              <h4>Travelling Add-Ons</h4>
                              <ul>
                                {categoryData[selectedCategory].travellingAddOns.map((item, idx) => (
                                  <li key={idx} onClick={() => navClick(selectedCategory, item)} style={{ cursor: 'pointer' }}>{item}</li>
                                ))}
                              </ul>
                            </div>
                            <div className="dropdown-banners-row">
                              <div className="banner-carousel">
                                <div className="banner-carousel-track" style={{ transform: `translateX(-${bannerIndex * 100}%)` }}>
                                  <div className="banner-carousel-slide">
                                    <img src={banners[0].src} alt={banners[0].alt} className="banner-carousel-img" />
                                    <img src={banners[1].src} alt={banners[1].alt} className="banner-carousel-img" />
                                  </div>
                                  <div className="banner-carousel-slide">
                                    <img src={banners[1].src} alt={banners[1].alt} className="banner-carousel-img" />
                                    <img src={banners[0].src} alt={banners[0].alt} className="banner-carousel-img" />
                                  </div>
                                </div>
                                <div className="banner-carousel-dots">
                                  {[0,1].map(i => (
                                    <span key={i} className={`banner-dot${i === bannerIndex ? ' active' : ''}`} />
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="nl-simple" aria-haspopup="true">
                    <a href="#why-corgif" className="nav-link" onClick={(e) => {
                      e.preventDefault();
                      if (window.location.pathname === '/') {
                        document.getElementById('why-corgif')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      } else {
                        window.location.href = '/#why-corgif';
                      }
                    }}>About corgif</a>
                  </li>
                  <li className="nl-simple" aria-haspopup="true">
                    <a href="/contact" className="nav-link">Contact</a>
                  </li>
                  {user && (
                    <>
                      <li className="nl-simple" aria-haspopup="true">
                        <a href="#" onClick={(e) => { e.preventDefault(); onCartClick(); }} className="nav-link" style={{ color: '#9A1111' }}>
                          <i className="fas fa-shopping-cart" style={{ color: '#9A1111' }}></i> Cart
                        </a>
                      </li>
                      <li className="nl-simple" aria-haspopup="true" style={{ position: 'relative' }}>
                        <a href="#" onClick={(e) => { e.preventDefault(); setShowNotifications(!showNotifications); }} className="icon-btn notification-icon-btn">
                          <i className="fas fa-bell"></i>
                          {notificationCount > 0 && <span className="notification-badge">{notificationCount}</span>}
                        </a>
                      </li>
                      <li className="nl-simple" aria-haspopup="true">
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                          <a href="#" className="icon-btn user-icon-btn">
                            <i className="fas fa-user-circle"></i>
                          </a>
                          <div className="account-dropdown">
                            <a href="#" onClick={(e) => { e.preventDefault(); onShowAccountDashboard(); }} className="dropdown-item">
                              <i className="fas fa-user-circle"></i> Account Dashboard
                            </a>
                            <a href="#" onClick={(e) => { e.preventDefault(); onShowOrders(); }} className="dropdown-item">
                              <i className="fas fa-history"></i> My Orders
                            </a>
                            <a href="#" onClick={(e) => { e.preventDefault(); onLogout(); }} className="dropdown-item logout">
                              <i className="fas fa-sign-out-alt"></i> Logout
                            </a>
                          </div>
                        </div>
                      </li>
                    </>
                  )}
                  {!user && (
                    <li className="nl-simple" aria-haspopup="true">
                      <a href="/login" className="btn signup-login-btn" style={{ textDecoration: 'none', color: 'white', backgroundColor: '#107FDF', borderRadius: '25px', padding: '6px 20px', minWidth: '155px', textAlign: 'center' }}>Signup/Login</a>
                    </li>
                  )}
                </ul>
                <div style={{ padding: '10px 0 10px 0', clear: 'both', display: 'flex', gap: '15px', alignItems: 'center', marginLeft: user ? '-50px' : '-250px', transition: 'margin-left 0.3s ease' }}>
                  <SearchResults onProductClick={onProductClick} />
                  <a href="#enterprise" className="btn enterprise-btn" onClick={(e) => {
                    e.preventDefault();
                    if (window.location.pathname === '/') {
                      document.getElementById('enterprise-wrapper')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                      window.location.href = '/#enterprise-wrapper';
                    }
                  }} style={{ backgroundColor: '#006400', color: 'white', borderRadius: '25px', padding: '10px 24px', textDecoration: 'none', whiteSpace: 'nowrap', fontWeight: '600', minWidth: '140px', textAlign: 'center' }}>For Enterprise</a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>

      {/* Compact Navbar */}
      <div className={`compact-header ${isScrolled ? 'compact-header-visible' : ''}`}>
        <div className="compact-header-container">
          <div className="compact-logo">
            <a href="corgif.html">
              <img src="images/corgif-logo.png" alt="corgif Logo" />
            </a>
          </div>
          
          <nav className="compact-nav">
            <a href="index.html" className="compact-nav-link">Home</a>
            <a href="#" className="compact-nav-link" onClick={(e) => {
              e.preventDefault();
              if (window.location.pathname === '/products') {
                window.location.href = '/products';
              } else if (window.location.pathname === '/') {
                document.getElementById('standard')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              } else {
                window.location.href = '/products';
              }
            }}>Shop</a>
            <a href="#why-corgif" className="compact-nav-link" onClick={(e) => {
              e.preventDefault();
              if (window.location.pathname === '/') {
                document.getElementById('why-corgif')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              } else {
                window.location.href = '/#why-corgif';
              }
            }}>About Corgif</a>
            <a href="/contact" className="compact-nav-link">Contact</a>
          </nav>

          <div className="compact-search-container">
            <SearchResults onProductClick={onProductClick} />
          </div>

          <div className="compact-actions">
            {user ? (
              <div className="compact-user-menu">
                <a href="#" onClick={(e) => { e.preventDefault(); setShowNotifications(!showNotifications); }} className="compact-icon-btn">
                  <i className="fas fa-bell"></i>
                  {notificationCount > 0 && <span className="compact-notification-badge">{notificationCount}</span>}
                </a>
                
                <div className="compact-profile-dropdown">
                  <a href="#" className="compact-icon-btn">
                    <i className="fas fa-user-circle"></i>
                  </a>
                  <div className="compact-dropdown-menu">
                    <a href="#" onClick={(e) => { e.preventDefault(); onCartClick(); }} className="compact-dropdown-item">
                      <i className="fas fa-shopping-cart" style={{ color: '#9A1111' }}></i> <span style={{ color: '#9A1111' }}>Cart</span>
                    </a>
                    <a href="#" onClick={(e) => { e.preventDefault(); onShowAccountDashboard(); }} className="compact-dropdown-item">
                      <i className="fas fa-user-circle"></i> Account
                    </a>
                    <a href="#" onClick={(e) => { e.preventDefault(); onShowOrders(); }} className="compact-dropdown-item">
                      <i className="fas fa-history"></i> Orders
                    </a>
                    <a href="#" onClick={(e) => { e.preventDefault(); onLogout(); }} className="compact-dropdown-item logout">
                      <i className="fas fa-sign-out-alt"></i> Logout
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              <a href="/login" className="compact-login-btn">Login</a>
            )}
          </div>
        </div>
      </div>
      {showNotifications && (
        <>
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10000 }} onClick={() => { setShowNotifications(false); fetchNotificationCount(); }} />
          <div style={{ position: 'fixed', top: '68px', right: '12px', zIndex: 10001 }}>
            <Notifications userId={user?.userId} onClose={() => { setShowNotifications(false); fetchNotificationCount(); }} isDropdown={true} />
          </div>
        </>
      )}
    </>
  );
}

export default Header;

